import React from 'react';
import { Tooltip, styled, } from '@mui/material';
import { tooltipClasses } from '@mui/material/Tooltip';

const HtmlTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme, customtheme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: customtheme.background.primary,
    color: customtheme.color.primary,
    maxWidth: 420,
    fontSize: 12,
    border: `1px solid ${customtheme.color.primary}`,
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: customtheme.color.primary,
  },
}));

export default HtmlTooltip;